import { render } from "./UiAuditStatusInfo.vue?vue&type=template&id=05c28547&ts=true"
import script from "./UiAuditStatusInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiAuditStatusInfo.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiAuditStatusInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05c28547"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05c28547', __exports__)) {
    api.reload('05c28547', __exports__)
  }
  
  module.hot.accept("./UiAuditStatusInfo.vue?vue&type=template&id=05c28547&ts=true", () => {
    api.rerender('05c28547', render)
  })

}


export default __exports__